<template>
  <section class="info-section info-section--thanks sz-primary-red sz-white--text">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h2 class="section-heading text-h2 font-weight-medium text-center">
            {{ $t('home.infoSection.title') }}
          </h2>
          <InfoSectionTiles />

          <InfoSectionTutorial class="mt-8" :tutorial-tiles="THANKS_TUTORIAL" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script setup lang="ts">
import { THANKS_TUTORIAL } from '@/constants/tutorial'
import InfoSectionTiles from './InfoSectionTiles.vue'
import InfoSectionTutorial from './Tutorial/InfoSectionTutorial.vue'
</script>
